/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type StepRecipeModal_configConstance$ref: FragmentReference;
declare export opaque type StepRecipeModal_configConstance$fragmentType: StepRecipeModal_configConstance$ref;
export type StepRecipeModal_configConstance = {|
  +speedLimit: ?number,
  +temperatureControlLimit: ?number,
  +temperatureDegreesMin: ?number,
  +temperatureDegreesMax: ?number,
  +$refType: StepRecipeModal_configConstance$ref,
|};
export type StepRecipeModal_configConstance$data = StepRecipeModal_configConstance;
export type StepRecipeModal_configConstance$key = {
  +$data?: StepRecipeModal_configConstance$data,
  +$fragmentRefs: StepRecipeModal_configConstance$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StepRecipeModal_configConstance",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "speedLimit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "temperatureControlLimit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "temperatureDegreesMin",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "temperatureDegreesMax",
      "storageKey": null
    }
  ],
  "type": "ConfigConstance"
};
// prettier-ignore
(node/*: any*/).hash = 'be81f5faad182464870e62c5a3a83a7a';

module.exports = node;
